import React from "react";
import "./tyre-services.css"; // create or reuse CSS
import { Link } from "react-router-dom";  
import { Helmet } from "react-helmet";
export default function TyreService() {
  return (
    <>
    <Helmet>
      <title>Tyre Inspection & Rotation Service in Palwal | AutoCare</title>
      <meta
        name="description"
        content="Ensure safety and smooth driving with Tyre Inspection & Rotation service at AutoCare in Palwal. Professional car repair services to maintain your tyres for optimal performance."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/tyre"
      />
    </Helmet>
    <section className="servicePage">
      <div className="serviceContent">
        {/* Left side text */}
        <div className="textContent">
          <h1>Tyre Inspection & Rotation Service</h1>

          <p>
            Ensure safety and smooth driving with our <strong>Tyre Inspection & Rotation</strong> service. 
            At <strong>AutoCare</strong>, we provide professional <span className="highlight">car repair</span> services. 
            Trusted <span className="highlight">Auto Care in Palwal</span>, we help maintain your tyres for optimal performance.
          </p>

          <h2>Why Tyre Inspection & Rotation is Important?</h2>
          <p>
            Regular tyre inspection and rotation improves tyre lifespan, ensures even wear, and enhances vehicle safety. 
            It prevents unexpected tyre damage and maintains smooth handling on all road conditions.
          </p>

          <h2>Our Tyre Inspection & Rotation Service Includes:</h2>
          <ul>
            <li>Tyre tread and sidewall inspection</li>
            <li>Tyre pressure check and adjustment</li>
            <li>Tyre rotation for even wear</li>
            <li>Balancing and alignment check if required</li>
            <li>Recommendations for tyre replacement if needed</li>
          </ul>

          <h2>Benefits of Choosing AutoCare</h2>
          <ul>
            <li>Expert technicians ensuring precise service</li>
            <li>Prolongs tyre life and improves fuel efficiency</li>
            <li>Enhances vehicle handling and safety</li>
            <li>Trusted <span className="highlight">car repair service</span> in Palwal</li>
            <li>Peace of mind with professional maintenance</li>
          </ul>

          <h2>Book Your Tyre Inspection & Rotation</h2>
          <p>
            Looking for a reliable <span className="highlight">car repair</span> service? 
            Schedule your <strong>Tyre Inspection & Rotation</strong> with <strong>AutoCare</strong> today.
          </p>

          <button className="primaryBtn"><Link to="/contact">Book Tyre Service</Link></button>
        </div>

        {/* Right side image */}
        <div className="imageContent">
          <img src="/carServiceImages/tyreservices.webp" alt="Tyre Inspection & Rotation Service" />
        </div>
      </div>
    </section>
    </>
  );
}
